import { PlusIcon } from "lucide-react"
import { type ReactNode, useState } from "react"
import { LabelCreateDialog } from "../settings/team/LabelCreateDialog"
import { Button } from "../ui/button"
import { SearchableSelect } from "../ui/searchable-select"
import { IssueLabel } from "./IssueLabel"

export function IssueLabelPicker({
	labels,
	selected,
	onChange,
	withSearch = false,
	disabled = false,
	noCollapse = false,
	children
}: {
	selected: string[]
	onChange: (selected: string[]) => void
	labels: { value: string; data: { color: string; name: string } }[]
	withSearch?: boolean
	disabled?: boolean
	noCollapse?: boolean
	children?: ReactNode
}) {
	const [search, setSearch] = useState("")
	return (
		<SearchableSelect
			multiple
			value={selected}
			onChange={onChange}
			disabled={disabled}
			searchable={withSearch}
			closeOnSelect={noCollapse}
			onSearchChange={setSearch}
			options={labels.map((label) => ({
				value: label.value.split("¦")[0]!,
				label: label.data.name,
				display: (
					<IssueLabel
						label={{ id: label.value.split("¦")[0]!, ...label.data }}
						truncateNameTo={30}
					/>
				)
			}))}
			empty={
				search ? (
					<LabelCreateDialog name={search}>
						<Button variant="ghost">
							<PlusIcon />
							Create a label named '{search}'
						</Button>
					</LabelCreateDialog>
				) : (
					"No labels found"
				)
			}
		>
			{children}
		</SearchableSelect>
	)
}
